module.exports = __webpack_public_path__ + "img/Zugtrupp.5913a2df.svg";